export default "__VITE_ASSET__411eea19__"